import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'frontoffice-app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class FrontofficeLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
